<template>
  <div>
    <Modal class="my-modal top" v-model="visible" transfer title="文章排序" :mask-closable="false" :footer-hide="true"
      width="800px">
      <div class="search-box">
        <div class="input-item">
          <span class="label">文章标题</span>
          <Input v-model="searchParams.title" clearable placeholder="请输入文章标题" />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="getList()">查询</Button>
        </div>
      </div>
      <Table ref="selection" :columns="columns" :data="tableData" row-key="id">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="topItem(row)">置顶</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
        style="text-align: center; margin-top: 20px" />
    </Modal>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  data() {
    return {
      visible: false,
      tableLoading: false, //表格loading
      searchParams: {
      },
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          type: "index",
        },
        {
          title: "文章标题",
          align: "center",
          key: "title",
          minWidth: 200,
          tree: true
        },
        {
          title: "发布时间",
          align: "center",
          key: "useTime",
          minWidth: 100,
          render(h, params) {
            const date = params.row.useTime ? params.row.useTime.substring(0, 16) : '';
            return <span>{date}</span>;
          },
        },
        {
          title: "操作",
          slot: "action",
          align: 'center',
          width: 130,
          fixed: 'right'
        }
      ],
      tableData: [],
    }
  },
  methods: {
    open(item) {
      this.visible = true;
      if (item.id) {
        this.searchParams.id = item.id;
        this.initListAjax('/buz/cmsColumn/article/list');
      }
    },
    topItem(row) {
      this.$notice.inquiry('是否置顶此选项？').then(async () => {
        this.$http({
          url: `/buz/cmsColumn/article/top`,
          type: 'POST',
          data: {
            isTop: true,
            id:row.articleId
          }
        }).then(res => {
          this.$Message.success('操作成功');
          this.getList();
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-modal-body {
    padding: 20px 20px 80px;
  }
  .input-item{
    width: 50%;
  }
}
</style>